export default "__VITE_ASSET__BkPvFnAS__"